import React, { useEffect, useState } from 'react';
import { IconCaptureImage, IconLocalCapture, IconRequestCapture } from '../../base/icons/svg';
import AbstractButton from './../../base/toolbox/components/AbstractButton';
import { onScreenShoot } from './function';
import ToolboxItem from '../../base/toolbox/components/ToolboxItem.web';
import ContextMenu from '../../base/ui/components/web/ContextMenu';
import { makeStyles } from 'tss-react/mui';
import { DRAWER_MAX_HEIGHT } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { showOverflowDrawer } from '../functions.web';
import Popover from '../../base/popover/components/Popover.web';
import { setToolbarHovered } from '../../toolbox/actions.web';
import { toState } from '../../base/redux/functions';
import ContextMenuItem from '../../base/ui/components/web/ContextMenuItem';
import { captureLargeVideo, requestCapture } from './functions-2';
/**
 * Button for take capture of the current video.
 */
class CaptureButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.icon = IconCaptureImage;
        this.label = 'Capturar Imagen';
        this.tooltip = 'Tomar captura de imagen a la cámara';
    }
    /**
     * Handles button click event.
     *
     * @private
     * @returns {void}
     * */
    _handleClick() {
        onScreenShoot();
    }
    render() {
        const props = {
            ...this.props,
            accessibilityLabel: this._getAccessibilityLabel(),
            elementAfter: this._getElementAfter(),
            icon: this._getIcon(),
            label: this._getLabel(),
            labelProps: this.labelProps,
            styles: this._getStyles(),
            toggled: this._isToggled(),
            tooltip: this._getTooltip()
        };
        return (React.createElement(CaptureButtonFunctional, { ...props }));
    }
}
const useStyles = makeStyles()((_theme, { overflowDrawer }) => {
    return {
        overflowMenuDrawer: {
            overflowY: 'scroll',
            height: `calc(${DRAWER_MAX_HEIGHT})`
        },
        contextMenu: {
            position: 'relative',
            right: 'auto',
            margin: 0,
            marginBottom: '8px',
            maxHeight: overflowDrawer ? undefined : 'calc(100dvh - 100px)',
            paddingBottom: "8px",
            minWidth: '240px',
            overflow: 'hidden'
        },
        content: {
            position: 'relative',
            maxHeight: overflowDrawer
                ? `calc(100% - 16px)` : `calc(100dvh - 100px)`,
            overflowY: 'auto'
        },
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0
        },
    };
});
const CaptureButtonFunctional = (props) => {
    const icon = IconCaptureImage;
    const label = 'Capturar Imagen';
    const tooltip = 'Tomar captura de imagen a la cámara';
    const overflowDrawer = useSelector(showOverflowDrawer);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const { hovered: isToolboxHovered } = useSelector((state) => (toState(state)['features/toolbox']));
    const { classes } = useStyles({ overflowDrawer });
    const handleClick = () => {
        const nextOpen = !isOpen;
        setIsOpen(nextOpen);
        dispatch(setToolbarHovered(nextOpen));
    };
    // keep the toolbar hovered
    useEffect(() => {
        if (isOpen && !isToolboxHovered) {
            dispatch(setToolbarHovered(true));
        }
    }, [isToolboxHovered, isOpen]);
    async function handleItemClick(callback) {
        setIsOpen(false);
        await callback();
    }
    async function handleLocalScreenshot() {
        handleItemClick(async () => {
            await captureLargeVideo();
        });
    }
    async function handleRequestCapture() {
        handleItemClick(async () => {
            await requestCapture();
        });
    }
    const overflowMenu = (React.createElement(ContextMenu, { className: classes.contextMenu, hidden: false, id: 'capture-context-menu', inDrawer: overflowDrawer, onKeyDown: () => { } },
        React.createElement("div", { className: classes.content },
            React.createElement(ContextMenuItem, { icon: IconLocalCapture, onClick: handleLocalScreenshot, accessibilityLabel: 'take local screenshot', text: 'Captura local' }),
            React.createElement(ContextMenuItem, { icon: IconRequestCapture, onClick: handleRequestCapture, accessibilityLabel: 'ask for high quality capture', text: 'Pedir captura' }))));
    return (React.createElement(Popover, { content: overflowMenu, headingId: 'capture-context-menu', onPopoverClose: () => { setIsOpen(false); }, onPopoverOpen: () => { setIsOpen(true); }, position: 'top', trigger: 'click', visible: isOpen },
        React.createElement(ToolboxItem, { ...props, icon: icon, label: label, tooltip: !isOpen ? tooltip : undefined, onClick: handleClick, toggled: isOpen })));
};
export default CaptureButton;
